import { Component} from '@angular/core';
import {EmploymentStateDBService} from '../../../../@db/employment-state-db.service';
import {LoanApplicationService} from '../../loan-application.service';
import {EmploymentStatus} from '../../../../@models/employment-status.model';
import {CountrySelectService} from '../../../../@modules/country-select/country-select.service';

@Component({
  selector: 'bb-career-details',
  templateUrl: './career-details.component.html',
  styleUrls: ['./career-details.component.scss']
})
export class CareerDetailsComponent {
  current_status = this.loan.form.get('current_status');
  employment_status = this.current_status.get('employment_status');
  looking = EmploymentStatus.KnownStatuses.looking;
  pre_employment = EmploymentStatus.KnownStatuses.pre_employment;
  done_requirements = EmploymentStatus.KnownStatuses.done_requirements;
  balik_manggagawa = EmploymentStatus.KnownStatuses.balik_manggagawa;
  working_flyback = EmploymentStatus.KnownStatuses.working_flyback;
  working = EmploymentStatus.KnownStatuses.working;
  job_title = this.loan.form.get('employment_info').get('job_title');
  destined_country = this.loan.form.get('employment_info').get('destined_country');

  constructor(public statuses: EmploymentStateDBService,
              public loan: LoanApplicationService,
              public country: CountrySelectService) {
  }
}
